import React, { useState, useEffect } from 'react';
import styles from './index.module.scss'
import TestBanner from '../../static/images_ae/testBanner.png';
import More from '../../static/images_ae/moreArrow.png';
import Pencil from '../../static/images_ae/icon-pencil.png';
import { ApiCore } from '../../api/index';
import { Toast } from 'antd-mobile-v5';
import { withRouter } from 'react-router-dom';

const api = new ApiCore();
const AeTestTools = () => {
    const [current, setCurrent] = useState('')

    const [typeList, setTypeList] = useState([])

    const [questionnaireList, setQuestionnaireList] = useState([])


    useEffect(() => {
        window.document.title = '自测量表';
        getData()
    }, [])


    const getData = () => {
        api.getQuestionnaireType().then((res: any) => {
            if (res.code == 0) {
                setTypeList(res.data)
                if (res.data && res.data.length > 0) {
                    setCurrent(res.data[0].code)
                    getList(res.data[0].code)
                }
            } else {
                Toast.show({
                    content: res.message
                })
            }
        })
        api.getQuestionnaireTag().then((res: any) => {
            if (res.code == 0) {
                const _data = res.data || [];
                setTypeList(_data);
                if (_data[0] && _data[0].code) {
                    setCurrent(res.data[0].code)
                    api.getAeQuestionnaireList(_data[0].code).then((result: any) => {
                        if (result.code == 0) {
                            setQuestionnaireList(result.data || [])
                        }
                    })

                }
                // const promiseArr: any = [];
                // _data.forEach((item: any) => {
                //     promiseArr.push(api.getAeQuestionnaireList(item.code));
                // });
                // Promise.all(catchFun(promiseArr)).then(result => {
                //     setQuestionnaireList()
                // })
            }
        })
    }

    // const catchFun = (promiseArr: any) => {
    //     return promiseArr.map((promise: any) => promise.catch((err: any) => Promise.resolve({})))
    // }

    const getList = (type: string) => {
        setCurrent(type)
        // api.getQuestionnaireList(type).then((res: any) => {
        api.getAeQuestionnaireList(type).then((res: any) => {
            if (res.code == 0) {
                setQuestionnaireList(res.data || [])
            } else {
                Toast.show({
                    content: res.message
                })
            }
        })
    }

    return (
        <div className={styles.testTools_container}>
            {/* <img className={styles.testBanner} src={TestBanner} alt="" /> */}
            <div className={styles.testBanner}>
            </div>
            <div className={styles.content}>

                <div className={styles.toolsTabs}>
                    {
                        typeList.map((v: any, i: number) => (
                            <div key={i} onClick={() => getList(v.code)} className={current == v.code ? `${styles.toolsTab} ${styles.active}` : styles.toolsTab}>{v.name}</div>
                        ))
                    }
                </div>

                <div className={styles.scale_list}>
                    {
                        questionnaireList.map((v: any, i: number) => (
                            <div className={v.completedState == 1 ? styles.scale : `${styles.scale} ${styles.completed}`} key={i}>
                                <div className={styles.scale_code}>{v.ename}</div>
                                <div className={styles.scale_name}>{v.cname}</div>
                                <div className={styles.scale_info}>
                                    <span className={styles.icon}></span>
                                    <span>{v.tip}</span>
                                </div>
                                <div className={styles.scale_btn}>
                                    {v.completedState == 0 ? '开始测评' : '重新测评'}
                                </div>
                                <div className={styles.tip}>
                                    {v.completedState == 0 ? `未测评${v.cycleType == 1 ? '( 建议一周一次 )' : v.cycleType == 2 ? '( 建议一月一次 )' : null}` : `历史评测${v.cycleType == 1 ? '( 本周已测 )' : v.cycleType == 2 ? '( 本月已测 )' : null}`}
                                    {v.completedState == 0 && <img className={styles.pencil} src={Pencil} alt="" />}
                                    {v.completedState == 1 && <img className={styles.more_arrow} src={More} alt="" />}
                                </div>
                            </div>
                        ))
                    }

                    {/* <div className={styles.scale}>
                        <div className={styles.scale_code}>EORTC QLQ-C30</div>
                        <div className={styles.scale_name}>癌症患者生命质量测定量表</div>
                        <div className={styles.scale_info}>
                            <span className={styles.icon}></span>
                            <span>10题 / 约3分钟</span>
                        </div>
                        <div className={styles.scale_btn}>
                            重新测评
                        </div>
                        <div className={styles.tip}>
                            历史评测报告(本月已测)
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    )
}

export default withRouter(AeTestTools);